<script setup>
import { useForm } from '@inertiajs/vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import HotelSubMenu from '@/Includes/HotelSubMenu.vue';
import { ref, onMounted } from "vue";
import FormModal from "@/Components/FormModal.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { useToast } from 'vue-toast-notification';
import { Modal } from 'bootstrap';

const props = defineProps({
    year: String,
    hotelsById: Object,
    flash: Object,
    factSheet: Number,
    user: Object,
});

let contactEditModal = ref(null);
let contactAddModal = ref(null);
let isLoading = ref(false);
const $toast = useToast();
let menu = 'details';
let modalShow = ref(null);
let thisModalObj = null;

onMounted(() => {
    thisModalObj = new Modal(modalShow.value);

    if (props.flash.message) {
        $toast.open({
            message: props.flash.message,
            type: "info",
            duration: 4000,
            position: 'top-right',
            class: 'bs-toast toast bg-dark show'
        });
    }
});

function showContactEditModal() {
    contactEditModal.value.show();
}
function showContactAddModal() {
    contactAddModal.value.show();
}
const FactsheetUploadForm = useForm({
    hotel_factsheet: null,
    hotel_id: props.hotelsById.id,
});

const ContactAddform = useForm({
    telephone: '',
    email: '',
    fax: '',
    website: '',
    addressline: '',
    hotel_id: props.hotelsById.id,
});

const FactsheetUploadFormSubmit = () => {
    FactsheetUploadForm.post('/hotels/storefactsheet', {
        preserveScroll: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
        onSuccess: () => {
            thisModalObj.hide(),
                $toast.open({
                    message: props.flash.message,
                    type: "info",
                    duration: 4000,
                    position: 'top-right',
                    class: 'bs-toast toast bg-dark show'
                });
        }
    });
};

const ContactEditform = useForm({
    telephone: props.hotelsById.contact[0] ? props.hotelsById.contact[0].telephone : '',
    email: props.hotelsById.contact[0] ? props.hotelsById.contact[0].email : '',
    fax: props.hotelsById.contact[0] ? props.hotelsById.contact[0].fax : '',
    website: props.hotelsById.contact[0] ? props.hotelsById.contact[0].website : '',
    addressline: props.hotelsById.contact[0] ? props.hotelsById.contact[0].addressline : '',
    hotel_id: props.hotelsById.id,
    contact_id: props.hotelsById.contact[0] ? props.hotelsById.contact[0].id : '',
});

const ContactAddFormSubmit = () => {
    ContactAddform.post('/contacts/store', {
        preserveScroll: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
        onSuccess: () => {
            contactAddModal.value.close(),
                ContactAddform.reset(),
                $toast.open({
                    message: props.flash.message,
                    type: "info",
                    duration: 4000,
                    position: 'top-right',
                    class: 'bs-toast toast bg-dark show'
                })
        }
    });
};

const ContactEditformSubmit = () => {
    ContactEditform.post('/contacts/update', {
        preserveScroll: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
        onSuccess: () => {
            contactEditModal.value.close(),

                $toast.open({
                    message: props.flash.message,
                    type: "info",
                    duration: 4000,
                    position: 'top-right',
                    class: 'bs-toast toast bg-dark show'
                })
        }
    });
};

const FormReset = () => {
    ContactAddform.reset();
    ContactAddform.clearErrors();
    ContactEditform.clearErrors();
    FactsheetUploadForm.clearErrors();
    FactsheetUploadForm.reset();
};
</script>
<style scoped>
@import "../../../../public/ui/vendor/libs/toastr/toastr.css";
</style>
<template>
    <AppLayout title="Hotel Details" :year=year :user=user>
        <div class="vld-parent">
            <Loading v-model:active="isLoading" :color="'#696cff'" />
        </div>
        <div class="container-xxl flex-grow-1 container-p-y">
            <HotelSubMenu :hotelsById="hotelsById" :menu="menu" :factSheet="factSheet" :user=user />
            <div class="row">
                <div class="col-xl-4 col-lg-5 col-md-5">
                    <div class="card mb-4">
                        <div class="card-body">
                            <small class="text-muted text-uppercase">About</small>
                            <ul class="list-unstyled mb-4 mt-3">
                                <li class="d-flex align-items-center mb-3">
                                    <i class="bx bx-building"></i><span class="fw-semibold mx-2">Name:</span>
                                    <span>{{ hotelsById.name }}</span>
                                </li>
                                <li class="d-flex align-items-center mb-3">
                                    <i class="bx bx-globe"></i><span class="fw-semibold mx-2">Country:</span>
                                    <span>{{ hotelsById.country.name }}</span>
                                </li>
                                <li class="d-flex align-items-center mb-3">
                                    <i class="bx bxs-city"></i><span class="fw-semibold mx-2">City:</span>
                                    <span>{{ hotelsById.city.name }}</span>
                                </li>
                                <li class="d-flex align-items-center mb-3">
                                    <i class="bx bx-info-circle"></i><span class="fw-semibold mx-2">Status:</span>
                                    <span v-if="hotelsById.active == 1" class="badge bg-label-success">Active</span>
                                    <span v-else class="badge bg-label-danger">Inactive</span>
                                </li>
                                <li class="d-flex align-items-center mb-3">
                                    <i class="bx bx-bookmark-alt"></i><span class="fw-semibold mx-2">Type:</span>
                                    <span>{{ hotelsById.property_type }}</span>
                                </li>
                            </ul>
                            <small v-if="hotelsById.contact[0]" class="text-muted text-uppercase">Contacts</small>
                            <ul v-if="hotelsById.contact[0]" class="list-unstyled mb-4 mt-3">
                                <li v-if="hotelsById.contact[0].telephone" class="d-flex align-items-center mb-3">
                                    <i class="bx bx-phone"></i><span class="fw-semibold mx-2">Contact:</span>
                                    <span>{{ hotelsById.contact[0].telephone }}</span>
                                </li>
                                <li v-if="hotelsById.contact[0].fax" class="d-flex align-items-center mb-3">
                                    <i class="bx bx-phone-incoming"></i><span class="fw-semibold mx-2">Fax:</span>
                                    <span>{{ hotelsById.contact[0].fax }}</span>
                                </li>
                                <li v-if="hotelsById.contact[0].email" class="d-flex align-items-center mb-3">
                                    <i class="bx bx-envelope"></i><span class="fw-semibold mx-2">Email:</span>
                                    <span>{{ hotelsById.contact[0].email }}</span>
                                </li>
                                <li v-if="hotelsById.contact[0].website" class="d-flex mb-3">
                                    <i class="bx bxl-chrome"></i><span class="fw-semibold mx-2">Website:</span>
                                    <span>{{ hotelsById.contact[0].website }}</span>
                                </li>
                                <li v-if="hotelsById.contact[0].addressline" class="d-flex align-items-left mb-4">
                                    <i class="bx bx-building"></i><span class="fw-semibold mx-2">Address:</span>
                                    <span>{{ hotelsById.contact[0].addressline }}</span>
                                </li>
                            </ul>
                            <button
                                v-if="hotelsById.contact[0] && $page.props.user.permissions.includes('edit-hotel-contact')"
                                class="btn btn-info" @click="showContactEditModal">Edit
                                Contact</button>

                            <button
                                v-if="!hotelsById.contact[0] && $page.props.user.permissions.includes('add-hotel-contact')"
                                class="btn btn-info" @click="showContactAddModal">Add Contact</button>
                        </div>
                    </div>
                </div>
                <div class="col-xl-8 col-lg-9 col-md-9">
                    <div class="card">
                        <div class="d-flex align-items-end row">
                            <div class="col-sm-9">
                                <div class="card-body">
                                    <h5 class="card-title text-primary">Hotel Description</h5>
                                    <p class="mb-4">
                                        <span v-html="hotelsById.description"></span>
                                    </p>

                                    <div class="mt-3">
                                        <div class="row">
                                            <div class="col-md-3">
                                                <h6 class="font-14">Check-in:</h6>
                                                <p class="text-sm lh-150">{{ hotelsById.check_in }} hrs</p>
                                            </div>
                                            <div class="col-md-3">
                                                <h6 class="font-14">Check-out:</h6>
                                                <p class="text-sm lh-150">{{ hotelsById.check_out }} hrs</p>
                                            </div>
                                            <div class="col-md-3">
                                                <h6 class="font-14">Time from airport:</h6>
                                                <p class="text-sm lh-150">{{ hotelsById.time_from_airport }} min</p>
                                            </div>
                                            <div class="col-md-3">
                                                <h6 class="font-14">Distance from airport:</h6>
                                                <p class="text-sm lh-150">{{ hotelsById.distance_from_airport }} Km</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-3 text-center ">
                                <div class="card-body pb-0 px-0 px-md-0">
                                    <img src="/ui/img/illustrations/hotel-waiting.gif" width="205" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <FormModal title="Edit Contact Details" ref="contactEditModal">
            <template #body>
                <h4 class="onboarding-title text-body mb-4">Edit Contact Details</h4>
                <form class="pl-3 pr-3">
                    <div class="row g-3">
                        <div class="col-md-6">
                            <label class="form-label" for="telephone">Contact Number</label>
                            <input v-model="ContactEditform.telephone" type="text" class="form-control"
                                :class="{ 'is-invalid': ContactEditform.errors.telephone }" name="telephone"
                                placeholder="Enter contact number">
                            <div v-if="ContactEditform.errors.telephone" class="invalid-feedback">
                                <div v-text="ContactEditform.errors.telephone">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label" for="email">Email</label>
                            <input v-model="ContactEditform.email" type="email" class="form-control" name="email"
                                :class="{ 'is-invalid': ContactEditform.errors.email }"
                                placeholder="Enter email address">
                            <div v-if="ContactEditform.errors.email" class="invalid-feedback">
                                <div v-text="ContactEditform.errors.email">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label" for="fax">Fax</label>
                            <input v-model="ContactEditform.fax" type="text" class="form-control" name="fax"
                                placeholder="Enter fax number">
                        </div>
                        <div class="col-md-6">
                            <label class="form-label" for="website">Website</label>
                            <input v-model="ContactEditform.website" type="text" class="form-control" name="website"
                                placeholder="Enter website address">
                        </div>
                        <div class="col-12">
                            <label class="form-label" for="address">Address</label>
                            <textarea v-model="ContactEditform.addressline" name="addressline" class="form-control"
                                :class="{ 'is-invalid': ContactEditform.errors.addressline }" rows="2"
                                placeholder="Enter hotel address"></textarea>
                            <div v-if="ContactEditform.errors.addressline" class="invalid-feedback">
                                <div v-text="ContactEditform.errors.addressline">
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </template>
            <template #footer>
                <button type="button" class="btn btn-label-secondary" data-bs-dismiss="modal" @click="FormReset()">
                    Close
                </button>
                <button @click="ContactEditformSubmit" class="btn btn-primary"
                    :disabled="ContactEditform.processing">Update</button>
            </template>
        </FormModal>

        <FormModal title="Add Contact Details" ref="contactAddModal">
            <template #body>
                <h4 class="onboarding-title text-body mb-4">Add Contact Details</h4>
                <form class="pl-3 pr-3">
                    <div class="row g-3">
                        <div class="col-md-6">
                            <label class="form-label" for="telephone">Contact Number</label>
                            <input v-model="ContactAddform.telephone" type="text" class="form-control"
                                :class="{ 'is-invalid': ContactAddform.errors.telephone }" name="telephone"
                                placeholder="Enter contact number">
                            <div v-if="ContactAddform.errors.telephone" class="invalid-feedback">
                                <div v-text="ContactAddform.errors.telephone">
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <label class="form-label" for="email">Email</label>
                            <input v-model="ContactAddform.email" type="email" class="form-control" name="email"
                                :class="{ 'is-invalid': ContactAddform.errors.email }"
                                placeholder="Enter email address">
                            <div v-if="ContactAddform.errors.email" class="invalid-feedback">
                                <div v-text="ContactAddform.errors.email">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label" for="fax">Fax</label>
                            <input v-model="ContactAddform.fax" type="text" class="form-control" name="fax"
                                placeholder="Enter fax number">
                        </div>
                        <div class="col-md-6">
                            <label class="form-label" for="website">Website</label>
                            <input v-model="ContactAddform.website" type="text" class="form-control" name="website"
                                placeholder="Enter website address">
                        </div>
                        <div class="col-12">
                            <label class="form-label" for="address">Address</label>
                            <textarea v-model="ContactAddform.addressline" name="addressline" class="form-control"
                                :class="{ 'is-invalid': ContactAddform.errors.addressline }" rows="2"
                                placeholder="Enter hotel address"></textarea>
                            <div v-if="ContactAddform.errors.addressline" class="invalid-feedback">
                                <div v-text="ContactAddform.errors.addressline">
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </template>
            <template #footer>
                <button type="button" class="btn btn-label-secondary" data-bs-dismiss="modal" @click="FormReset()">
                    Close
                </button>
                <button @click="ContactAddFormSubmit" class="btn btn-primary"
                    :disabled="ContactAddform.processing">Add</button>
            </template>
        </FormModal>

        <div class="modal fade" id="factsheetModal" tabindex="-1" aria-modal="true" role="dialog" ref="modalShow">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Upload Factsheet</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <hr>
                    <form @submit.prevent="FactsheetUploadFormSubmit">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col mb-3">
                                    <label for="factsheet" class="form-label">Fact Sheet</label>
                                    <input type="file" name="hotel_factsheet" class="form-control"
                                        @input="FactsheetUploadForm.hotel_factsheet = $event.target.files[0]"
                                        :class="{ 'is-invalid': FactsheetUploadForm.errors.hotel_factsheet }">
                                    <progress v-if="FactsheetUploadForm.progress"
                                        :value="FactsheetUploadForm.progress.percentage" max="100">
                                        {{ FactsheetUploadForm.progress.percentage }}%
                                    </progress>
                                    <div v-if="FactsheetUploadForm.errors.hotel_factsheet" class="invalid-feedback">
                                        <div v-text="FactsheetUploadForm.errors.hotel_factsheet">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" href="#" class="btn btn-label-secondary" data-bs-dismiss="modal"
                                @click="FormReset">
                                Close
                            </button>
                            <button type="submit" class="btn btn-primary">Upload</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </AppLayout>
</template>